module.exports = __webpack_public_path__ + "static/media/logo.02559e3a.png";